// store/campaigns/types.ts

export interface Pagination {
  page: number      // zero-based page index
  size: number      // page size
  pages: number     // total pages
  elements: number  // total elements
  first: boolean
  last: boolean
}

export interface CampaignSummaryDto {
  id: string
  name: string
  status: string
  channels: string[]
  scheduledTime?: string    // ISO datetime
  totalRecipients?: number
  sentCount?: number
}

// if you need more fields when viewing/editing a single campaign:
export interface CampaignDetailDto extends CampaignSummaryDto {
  description?: string
  campaign_type?: string
  // …any other “detail” properties
}

export enum CampaignActionTypes {
  GET_CAMPAIGNS_REQUEST   = "@@campaign/GET_CAMPAIGNS_REQUEST",
  GET_CAMPAIGNS_SUCCESS   = "@@campaign/GET_CAMPAIGNS_SUCCESS",
  GET_CAMPAIGNS_ERROR     = "@@campaign/GET_CAMPAIGNS_ERROR",

  GET_CAMPAIGN_REQUEST    = "@@campaign/GET_CAMPAIGN_REQUEST",
  GET_CAMPAIGN_SUCCESS    = "@@campaign/GET_CAMPAIGN_SUCCESS",
  GET_CAMPAIGN_ERROR      = "@@campaign/GET_CAMPAIGN_ERROR",

  CREATE_CAMPAIGN_REQUEST = "@@campaign/CREATE_CAMPAIGN_REQUEST",
  CREATE_CAMPAIGN_SUCCESS = "@@campaign/CREATE_CAMPAIGN_SUCCESS",
  CREATE_CAMPAIGN_ERROR   = "@@campaign/CREATE_CAMPAIGN_ERROR",

  UPDATE_CAMPAIGN_REQUEST = "@@campaign/UPDATE_CAMPAIGN_REQUEST",
  UPDATE_CAMPAIGN_SUCCESS = "@@campaign/UPDATE_CAMPAIGN_SUCCESS",
  UPDATE_CAMPAIGN_ERROR   = "@@campaign/UPDATE_CAMPAIGN_ERROR",

  DELETE_CAMPAIGN_REQUEST = "@@campaign/DELETE_CAMPAIGN_REQUEST",
  DELETE_CAMPAIGN_SUCCESS = "@@campaign/DELETE_CAMPAIGN_SUCCESS",
  DELETE_CAMPAIGN_ERROR   = "@@campaign/DELETE_CAMPAIGN_ERROR",
}

export interface CampaignState {
  readonly list: CampaignSummaryDto[]
  readonly pagination: Pagination | null
  readonly current?: CampaignDetailDto
  readonly loading: boolean
  readonly error: string | null
}
